import { ILayerFactory } from "../layerFactory/ILayerFactory";

/**
 * 出力不可レイヤ選択時エラークラス
 */
export class UnexportableLayerError {
  /**
   * 表示中レイヤ
   */
  constructor(private _visibleLayers: ILayerFactory[]) {}
  /**
   * 表示中レイヤ名リストを取得
   */
  getVisibleLayersName(): string[] {
    return this._visibleLayers.map((e) => e.constructor.name);
  }
}
